'use strict';
import {module} from '../app';
import * as _ from 'lodash';

module
  .factory('otherStudyDetailsViewModel', [
    '$state', 'Worklist', 'techpadConfig', 'OutsideStudy', 'modalService', 'ionicDatePicker', 'dataRetrieverService', 'techpadOptions', 'environmentHelper', 'datePickerService',
    function ($state, Worklist, techpadConfig, OutsideStudy, modalService, ionicDatePicker, dataRetrieverService, techpadOptions, environmentHelper, datePickerService) {
      let vm = function (worklistId) {
        let self = this;
        self.loading = true;
        self.techpadSettings = techpadConfig.settings;
        self.isIOSDevice = environmentHelper.isIOSDevice();

        const NewItemId = 'NEW';
        
        const DefaultFutureYearsForOutsideStudies = 25; 
        const DefaultFutureMonthForOutsideStudies = 11; 
        const DefaultFutureDayForOutsideStudies = 31; 
        const DefaultLocationName = 'An outside location';
        const DefaultLocationId = 0;

        techpadOptions.getOptions();
        self.darkMode = techpadOptions.options.DarkMode;

        self.procTypes = [
          {Key: 'M', Value: 'Mammography'},
          {Key: 'U', Value: 'Ultrasound'},
          {Key: 'D', Value: 'Ductography'},
          {Key: 'R', Value: 'Breast MRI'},
          {Key: 'X', Value: 'Bone Densitometry'},
          {Key: 'MU', Value: 'Mammo/US'},
          {Key: 'O', Value: 'Other'}
        ];

        dataRetrieverService.cachedProxy('worklist-all-locations', 0, Worklist.getAllLocations)
          .then(function (resp) {
            self.locations = resp.data;

            const isAnyDefaultLocation = _.find(self.locations, x => x.Key == DefaultLocationId);

            if (!isAnyDefaultLocation) {
              self.locations.push({
                Key: DefaultLocationId,
                Value: DefaultLocationName
              });
            }

          }, function () {
            self.locations = [];
          });

        Worklist.getVisitReasons().then(function (resp) {
          self.viewsTypes = resp.data;
        });

        self.refresh = function () {
          self.loading = true;

          dataRetrieverService.cachedProxy('outside-study-' + self.ssn, 0, function () {
            return OutsideStudy.getForPatient(self.ssn);
          }).then(async function (resp) {
            self.studies = resp.data;
            if (self.selectedStudyId) {
              const showConfirmation = false;
              await self.selectStudy(_.find(self.studies, {Id: self.selectedStudyId}), showConfirmation);
            } else {
              self.currentStudy = null;
            }
            self.loading = false;
          }, function (resp, status) {
            self.loading = false;
            modalService.showErrorMessage(resp.data, resp.status);
          });
        };

        self.safeRefresh = function () {
          if (!self.currentStudy || angular.equals(self.currentStudy, self.currentStudyOriginal)) {
            self.refresh();
            return;
          }

          modalService.showConfirmation(function () {
            self.refresh();
          }, 'You have unsaved changes for this study, are you sure you want to revert them?');
        };

        self.reloadStudies = function (selectLast) {
          self.loading = true;
          OutsideStudy.getForPatient(self.ssn).then(async function (resp) {
            self.studies = resp.data;
            if (selectLast) {
              const showConfirmation = true;
              await self.selectStudy(self.studies[self.studies.length - 1], showConfirmation);
            }
            self.loading = false;
          });
        };

        self.onSelectStudy = async function (study, withRevert) {
          if (withRevert) {
            if (self.selectedStudyId === NewItemId) {
              await self.deleteStudy();
            }
          }
          self.forceSelectStudy(study);
        };

        self.selectStudy = async function (study, showConfirmation) {
          if (!study || self.selectedStudyId === study.Id) {
            return;
          }

          const isModelChanged = self.modelChanged();
          if (!self.currentStudy || !isModelChanged) {
            self.forceSelectStudy(study);
          } else {
            const withRevert = true;
            if (showConfirmation) {
              modalService.showConfirmation(async function () {
                await self.onSelectStudy(study, withRevert);
              }, 'You have unsaved changes for this study, are you sure you want to revert them?');
            } else {
              await self.onSelectStudy(study, withRevert);
            }
          }
        };

        self.forceSelectStudy = function (study) {
          self.currentStudy = angular.copy(study);

          self.currentStudyOriginal = angular.copy(study);
          if (!study.Id) {
            self.currentStudy.Id = NewItemId;
          }
          self.selectedStudyId = study.Id;
        };

        self.createAndSelectStudy = async function (force) {
          let newStudy = {Date: new Date(), Id: NewItemId, Ssn: self.ssn, Loc_num: 0};
          self.studies.push(newStudy);
          if (force) {
            self.forceSelectStudy(newStudy);
          } else {
            const showConfirmation = true;
            await self.selectStudy(newStudy, showConfirmation);
          }
        };

        self.createStudy = async function () {
          const isCurrentStudyChanged = self.currentStudy && self.modelChanged();
          const isCurrentStudyNew = self.currentStudy && self.currentStudy.Id === NewItemId;
          if ((isCurrentStudyChanged || isCurrentStudyNew)) {
            modalService.showConfirmation(async function () {
              if (isCurrentStudyNew) {
                await self.deleteStudy();
              }

              self.currentStudy = null;
              self.currentStudyOriginal = null;
              const isForce = true;
              await self.createAndSelectStudy(isForce);
            }, 'You have unsaved changes for this study, are you sure you want to revert them?');
          } else {
            const isForce = false;
            await self.createAndSelectStudy(isForce);
          }
        };

        self.modelChanged = function () {
          let isChanged = false;
          if (!isChanged) {
            isChanged = self.currentStudy && (self.currentStudy.Id === NewItemId || !angular.equals(self.currentStudy, self.currentStudyOriginal));
          }

          return isChanged;
        };

        self.isActive = function (study) {
          const isActive = angular.equals(self.currentStudyOriginal, study);

          return isActive;
        };

        self.deleteStudy = async function () {
          self.saved = false;
          let study = self.currentStudy;

          if (study.Id === NewItemId) {
            self.studies.splice(self.studies.indexOf(study), 1);
            self.currentStudy = null;
            self.selectedStudyId = null;
            return;
          }

          let confirmed = await modalService.showConfirmation(function () {
            self.loading = true;
            OutsideStudy.deleteStudy(study.Id).then(
              function () {
                self.loading = false;
                self.currentStudy = null;
                self.selectedStudyId = null;
                self.reloadStudies();
              },
              function (resp, status) {
                self.loading = false;
                modalService.showErrorMessage(resp.data, resp.status);
              });
          }, 'Are you sure you want to delete this study?');
        };

        self.save = function () {
          self.loading = true;
          self.saved = false;
          let isNew = false;
          if (self.currentStudy.Id === NewItemId) {
            self.currentStudy.Id = '';
            isNew = true;
          }
          OutsideStudy.post(self.currentStudy).then(function () {
            self.loading = false;
            if (isNew) {
              self.currentStudy = null;
              self.currentStudyOriginal = null;
            } else {
              self.currentStudyOriginal = angular.copy(self.currentStudy);
            }
            self.reloadStudies(isNew);
            self.saved = true;
          }, function (resp, status) {
            self.loading = false;
            modalService.showErrorMessage(resp.data, resp.status);
            if (isNew) {
              self.currentStudy.Id = NewItemId;
            }
          });
        };

        self.changeDate = function () {
          let maxDate = new Date(new Date().getFullYear() + DefaultFutureYearsForOutsideStudies, DefaultFutureMonthForOutsideStudies, DefaultFutureDayForOutsideStudies);
          
          const changeDateModel = {
            obj: self.currentStudy,
            id: 'Date',
            maxDate
          };

          datePickerService.changeDate(changeDateModel);
        };

        self.goBack = async function () {
          const isModelChanged = self.modelChanged();
          if (isModelChanged) {
            let confirmed = await modalService.showConfirmation(function () {
              $state.go('root.worklist');
            }, 'You have unsaved changes for this study, are you sure you want to revert them?');
          } else {
            $state.go('root.worklist');
          }
        };

        self.getLabel = function (key, collection) {
          let label = '';
          if (collection) {
            let item = {};
            const matchingItems = collection.filter((item) => item.Key == key);
            if (matchingItems && matchingItems.length) {
              item = matchingItems[0];
            }
            label = item.Value;
          }
          return label;
        };

        self.loc_numChanged = function () {
          if (self.currentStudy.Loc_num || self.currentStudy.Loc_num === 0) {
            self.currentStudy.Locname = null;
          }
        };

        self.changeOtherStudyLocation = function (item) {
          self.currentStudy.Loc_num = item;
        };

        self.changeOtherStudyProcedureType = function (item) {
          self.currentStudy.Proctype = item;
        };

        self.changeOtherStudyExamReason = function (item) {
          self.currentStudy.Scr_pro = item;
        };

        Worklist.getPatientByWorklist(worklistId).then(
          (resp) => {
            self.patient = resp.data;
            self.ssn = self.patient.Ssn;
            self.reloadStudies();
          },
          (errorResp) => {
            modalService.showAlert(errorResp);
          });
      };

      return vm;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/otherStudyDetails.js